<template>
<div>
  <v-dialog :value="dialog" max-width="460" transition="fade" persistent>
    <v-card v-if="form && dialog">
      <v-card-title class="headline"></v-card-title>
      <v-card-text>
        <div class="schedule-confirmation-dialog-text">
            <svg
              id="successAnimation"
              class="animated"
              xmlns="http://www.w3.org/2000/svg"
              width="50"
              height="50"
              viewBox="0 0 70 70"
            >
              <path
                id="successAnimationResult"
                fill="#D8D8D8"
                d="M35,60 C21.1928813,60 10,48.8071187 10,35 C10,21.1928813 21.1928813,10 35,10 C48.8071187,10 60,21.1928813 60,35 C60,48.8071187 48.8071187,60 35,60 Z M23.6332378,33.2260427 L22.3667622,34.7739573 L34.1433655,44.40936 L47.776114,27.6305926 L46.223886,26.3694074 L33.8566345,41.59064 L23.6332378,33.2260427 Z"
              />
              <circle
                id="successAnimationCircle"
                cx="35"
                cy="35"
                r="24"
                stroke="#979797"
                stroke-width="2"
                stroke-linecap="round"
                fill="transparent"
              />
              <polyline
                id="successAnimationCheck"
                stroke="#979797"
                stroke-width="2"
                points="23 34 34 43 47 27"
                fill="transparent"
              />
            </svg>

            <br /><br />
          <div
            style="color: #32e382; width: 100%; text-align: center; font-weight: 900; font-size: 32px; text-transform: uppercase; line-height: 1.2;"
          >
            Aula<br>Marcada
          </div>

          <br />
          <hr style="border: none; border-top: 2px solid #bfb5c9;" class="mx-10">
          <br />
          Aula particular de<br />
          <span>{{ subject.name }} </span><br />
          com prof.<br />
          <span>{{ professorName(form.professor_id) }} </span><br />
          <span>{{ weekdayMapper(form.day_of_week) }} </span> às
          <span>{{ form.start_at }}h</span> <br />
          (
          {{
            new Date(form.date).toLocaleString("pt-BR", {
              day: "numeric",
              month: "long",
              timeZone: "UTC"
            })
          }}
          )<br />
          <span v-if="form.classroom_id">{{ classroomName(form.classroom_id) }}</span>
          <span v-else>Home School</span>

        </div>
        <div class="text-center">
          <v-btn
          @click="confirmVisibility = true"
          color="grey"
          class="px-5 mt-3 mb-12"
          rounded
          depressed
          outlined
        >
          Desmarcar aula
        </v-btn>
        <br/>

        <v-btn
          color="primary"
          class="px-5 mt-5"
          rounded
          depressed
          @click="$emit('negative')"
        >
          Fechar
        </v-btn>
        </div>

      </v-card-text>
    </v-card>
  </v-dialog>
    <ConfirmUnscheduleClass
      :visibility="confirmVisibility"
      :classData="form"
      @positive="cancelClass"
      @negative="confirmVisibility = false"
    />
</div>
</template>

<script>
import DialogMixin from "@/mixins/dialogs/DialogMixin";
import { mapState } from "vuex";
import weekdayMapper from "@/models/weekdayMapper";
import StudentsRepository from "@/repositories/StudentsRepository";
import ConfirmUnscheduleClass from './ConfirmUnscheduleClass'

export default {
  mixins: [DialogMixin],
  components: {
    ConfirmUnscheduleClass
  },
  props: {
    subject: Object
  },
  data() {
    return {
      defaultForm: undefined,
      confirmVisibility: false,
      weekdayMapper: weekdayMapper
    };
  },

  computed: {
    ...mapState(["professors", "classrooms"])
  },

  methods: {
    professorName(professorId) {
      const professor = this.professors.find(
        professor => professor && professor.user_id === professorId
      );

      return professor ? professor.name : "";
    },
    classroomName(classroomId) {
      const classroom = this.classrooms.find(
        classroom => classroom && classroom.id === classroomId
      );

      return classroom ? classroom.name : "";
    },
    async cancelClass() {
      let response = await StudentsRepository.cancelClass(this.form.id)
      this.$emit("destroy");
    }
  }
};
</script>

<style scoped>
@keyframes scaleAnimation {
  0% {
    opacity: 0;
    transform: scale(3);
  }
  100% {
    opacity: 1;
    transform: scale(2);
  }
}

@keyframes drawCircle {
  0% {
    stroke-dashoffset: 151px;
  }
  100% {
    stroke-dashoffset: 0;
  }
}

@keyframes drawCheck {
  0% {
    stroke-dashoffset: 60px;
  }
  100% {
    stroke-dashoffset: 0;
  }
}

@keyframes fadeOut {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}

@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

#successAnimationCircle {
  stroke-dasharray: 151px 151px;
  stroke: #32e382;
}

#successAnimationCheck {
  stroke-dasharray: 60px 60px;
  stroke: #32e382;
}

#successAnimationResult {
  fill: #32e382;
  opacity: 0;
}

#successAnimation.animated {
  animation: 2s ease-out 0s 1 both scaleAnimation;
}

#successAnimationCircle {
  animation: 1s cubic-bezier(0.77, 0, 0.175, 1) 0s 1 both drawCircle,
    0.3s linear 0.9s 1 both fadeOut;
}

#successAnimationCheck {
  animation: 1s cubic-bezier(0.77, 0, 0.175, 1) 0s 1 both drawCheck,
    0.3s linear 0.9s 1 both fadeOut;
}

#successAnimationResult {
  animation: 0.3s linear 0.9s both fadeIn;
}

#replay {
  background: rgba(255, 255, 255, 0.2);
  border: 0;
  border-radius: 3px;
  bottom: 100px;
  color: #fff;
  left: 50%;
  outline: 0;
  padding: 10px 30px;
  position: absolute;
  transform: translateX(-50%);
}
#replay:active {
  background: rgba(255, 255, 255, 0.1);
}
</style>
